var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertsIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    fillRule: "nonzero",
    d: "M14.11 13.372h-2.23L11.566 4h2.86l-.315 9.372zm-1.115 1.467c.452 0 .816.133 1.092.4.275.266.413.606.413 1.021 0 .409-.138.746-.413 1.012-.276.267-.64.4-1.092.4-.445 0-.806-.133-1.082-.4-.275-.266-.413-.603-.413-1.012 0-.409.138-.748.413-1.017.276-.27.637-.404 1.082-.404z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f00a0",
    d: "M6.594 24.992L11.05 21.5H25a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5H1a.5.5 0 0 0-.5.5v20a.5.5 0 0 0 .5.5h5.51l.084 3.492z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIconGreen);
export default __webpack_public_path__ + "static/media/alerts_icon_green.bfc2f010a473fb32d1e5c218210b75ae.svg";
export { ForwardRef as ReactComponent };